/* Chrome 20 / IE11: addEventListener third arg must be boolean, not { passive } */
(function () {
  if (typeof EventTarget === "undefined") {
    return;
  }

  var proto = EventTarget.prototype;
  var nativeAdd = proto.addEventListener;
  var nativeRemove = proto.removeEventListener;

  if (!nativeAdd || !nativeRemove) {
    return;
  }

  proto.addEventListener = function (
    type: string,
    listener: EventListenerOrEventListenerObject | null,
    options?: boolean | { capture?: boolean; passive?: boolean; once?: boolean }
  ) {
    if (options && typeof options === "object") {
      return nativeAdd.call(this, type, listener, options.capture === true);
    }
    return nativeAdd.call(this, type, listener, options as boolean);
  };

  proto.removeEventListener = function (
    type: string,
    listener: EventListenerOrEventListenerObject | null,
    options?: boolean | { capture?: boolean; passive?: boolean; once?: boolean }
  ) {
    if (options && typeof options === "object") {
      return nativeRemove.call(this, type, listener, options.capture === true);
    }
    return nativeRemove.call(this, type, listener, options as boolean);
  };
})();
